/**
 * resolvePlayerAvatar — única fuente de verdad para el avatar del jugador.
 *
 * Reglas (Fase 08):
 *  - Si `profile_photo` existe → siempre se usa.
 *  - Si no existe:
 *      gender = 'male'   → chico.png (local)
 *      gender = 'female' → chica.png (local)
 *      gender = 'not_specified' o ausente → genericFallback (avatar genérico existente)
 *  - Si se elimina la foto original → vuelve al avatar por género (no se guarda nada).
 *  - Si cambia el género sin foto → la función devuelve automáticamente el nuevo avatar.
 *
 * Uso:
 *   import { resolvePlayerAvatar } from '@/lib/playerAvatar';
 *   const url = resolvePlayerAvatar({ profile_photo: profile?.profile_photo, gender: profile?.gender });
 */
import chicoImg from '@/assets/player-defaults/chico.png';
import chicaImg from '@/assets/player-defaults/chica.png';

const GENERIC_FALLBACK = null; // null → el componente Avatar usará sus iniciales o icono

export function resolvePlayerAvatar(profile, options = {}) {
  if (!profile) return options.genericFallback ?? GENERIC_FALLBACK;
  const photo = profile.profile_photo || profile.profilePhoto;
  if (photo && typeof photo === 'string' && photo.trim().length > 0) {
    // Si es ruta del backend (/api/uploads/...) o URL absoluta
    if (photo.startsWith('/api/') && options.backendBaseUrl) {
      return `${options.backendBaseUrl}${photo}`;
    }
    return photo;
  }
  const gender = (profile.gender || '').toLowerCase();
  if (gender === 'male') return chicoImg;
  if (gender === 'female') return chicaImg;
  return options.genericFallback ?? GENERIC_FALLBACK;
}

export const PLAYER_AVATAR_FALLBACKS = {
  male: chicoImg,
  female: chicaImg,
};
